export default __webpack_public_path__ + "static/media/misc-books5-1440w.e6805076.png";